import { createGlobalStyle } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { IconFontFileName, iconFontVersion } from "./iconFontVersion.mjs.mjs";
const DEFAULT_FONT_URL = 'https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2';
const DEFAULT_ICON_FONT_URL = `https://react.ui.audi/assets/webfonts/icon/${IconFontFileName}`;
export const GlobalStyles = createGlobalStyle `
  @font-face {
    font-weight: 400 700;
    font-family: 'AudiType';
    font-style: normal;
    font-stretch: 100% 130%;
    src: url(${(props) => props.fontUrl || DEFAULT_FONT_URL})
      format('woff2-variations');
    font-display: swap;
  }

  @font-face {
    font-family: "audi-iconfont-${iconFontVersion}";
    src: url(${(props) => props.iconFontUrl || DEFAULT_ICON_FONT_URL})
    format('woff2-variations');
    font-display: block;
    font-weight: normal;
    font-style: normal;
  }
`;
//# sourceMappingURL=GlobalStyles.mjs.mjs.map